import { ProductPricingOptionDTO } from '@iota/iota-management-portal-v4-client';
import { createReducer, createSelector, on } from '@ngrx/store';
import { LoadConfigFailure, LoadDefaultProductPricingOptions, LoadDefaultProductPricingOptionsSuccess } from '../actions/config.actions';
import { AppState } from '../store';

export interface ConfigState {
    loading: boolean;
    error: any;
    defaultProductPricingOptions: { [key: string]: ProductPricingOptionDTO[] };
}

export const initialState: ConfigState = {
    loading: false,
    error: undefined,
    defaultProductPricingOptions: undefined
};

export const configReducer = createReducer(
    initialState,
    on(LoadDefaultProductPricingOptions, (state) => ({ ...state, loading: true })),
    on(LoadDefaultProductPricingOptionsSuccess, (state, { result }) => ({
        ...state,
        loading: false,
        defaultProductPricingOptions: JSON.parse(result)
    })),

    on(LoadConfigFailure, (state, { error }) => ({ ...state, error, loading: false }))
);

export const configState = (state: AppState) => state.configState;
export const configLoading = createSelector(configState, ({ loading }) => loading);
export const configError = createSelector(configState, ({ error }) => error);
export const defaultProductPricingOptions = createSelector(configState, ({ defaultProductPricingOptions }) => defaultProductPricingOptions);
